import { faro } from '@grafana/faro-web-sdk';
import { useEffect } from 'react';
import { useRouteError } from 'react-router-dom';

export function RouteErrorBoundary() {
  const error = useRouteError();

  useEffect(() => {
    faro.api.pushError(error instanceof Error ? error : new Error(String(error)));
  }, [error]);

  return (
    <div>
      <h1>Something went wrong!</h1>
      <p>{error instanceof Error ? error.message : String(error)}</p>
    </div>
  );
}
